module.exports = __webpack_public_path__ + "assets/close-icon.410d9b8a.svg";